import React, { Component } from 'react'
import { StyledContent } from '../../styles/mixins'
import { StyledCard } from './style'
import { Row, Col, Spin, Card } from 'antd';
import imgLogo from '../../static/images/imgLogo.png';
import ReactMarkdown from 'react-markdown'
import ApiService from '../../actions/apiService';
const { Meta } = Card;

class Shop extends Component {
  state = {
    content: 'Trading is a long-term process that we refine over time and through experience. OptionsEDU is focused on using our experience to deliver ideas, tools, and knowledge to the options trading community.',
    isLoading: true,
  }
  
  async componentWillMount() {
    const response = await ApiService.getMethod('/pages/mainhomepage');
    if (response) {
      this.setState({
        content: response,
      })
    }
    this.setState({
      isLoading: false,
    });
  }
  
  onRedirect = (path) => {
    this.props.history.push({
      pathname: path,
    });
  }
  
  
  render() {
    
    return (
      <StyledContent>
        <StyledCard bordered={false}>
          <Row gutter={16}>
            <Col sm={24} xs={24}>
              <center>
                <img src={imgLogo} alt="logo" />
                {
                  this.state.isLoading ? <div className="mtb-50"><Spin/></div> : <div className="mtb-50"><ReactMarkdown escapeHtml={false} source={this.state.content} /></div>
                }
              </center>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col sm={12} xs={24} offset={6}>
              <Col span={8}>
                <Card onClick={this.props.onLogin} >Members Area</Card>
              </Col>
              <Col span={8}>
                <Card onClick={() => this.onRedirect('/posts')}>Open Posts</Card>
              </Col>
              <Col span={8}>
                <Card onClick={() => this.onRedirect('/shop')}>Shop</Card>
              </Col>
            </Col>
          </Row>
        </StyledCard>
      </StyledContent>
    )
  }
}

export default Shop



// WEBPACK FOOTER //
// ./src/components/Home/index.js